var _polygon, _path, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 22 2 16.14 2 7.86 7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22",
    fill: "#c4223a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.94,2.5,21.5,8.06v7.87L15.94,21.5H8.06L2.5,15.93V8.06L8.06,2.5h7.88m.41-1H7.65l-.29.29L1.79,7.36l-.29.29v8.7l.29.29,5.57,5.57.29.29h8.7l.29-.29,5.57-5.57.29-.29V7.65l-.29-.29L16.64,1.79l-.29-.29Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.49 8.8 15.2 7.51 12 10.71 8.8 7.51 7.51 8.8 10.71 12 7.51 15.2 8.8 16.49 12 13.29 15.2 16.49 16.49 15.2 13.29 12 16.49 8.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7279973d922c13d1683192df775a3b26.svg";
export { ForwardRef as ReactComponent };